import request from '@/utils/request'
// 数据查询
//仓库数据查询
export function findwarehouse(data) {
  return request({
    url: '/api/out/warehouse/findwarehouse',
    method: 'post',
    data
  })
}
//仓库数据查询
export function pagewarehouse(data) {
  return request({
    url: '/api/out/warehouse/pagewarehouse',
    method: 'post',
    data
  })
}
//仓库数据新增
export function addwarehouse(data) {
  return request({
    url: '/api/out/warehouse/addwarehouse',
    method: 'post',
    data
  })
}
//仓库数据删除
export function deletewarehouse(data) {
  return request({
    url: '/api/out/warehouse/deletewarehouse',
    method: 'post',
    data
  })
}
//仓库数据修改
export function updatewarehouse(data) {
  return request({
    url: '/api/out/warehouse/updatewarehouse',
    method: 'post',
    data
  })
}
